import { IconHeadset } from './IconHeadset'

export default IconHeadset
